import webContextProvider from "../../providers/webContextProvider";

export default ({ variantId } = {}) => {
  const { storeId: store } = webContextProvider();
  const baseUrl = `/api/marketing/backinstock/v1/customers/me/stores/${store}/variants`;

  if (variantId) {
    return baseUrl + "/" + variantId;
  }

  return baseUrl;
};
